<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12 common_title">
       <h2>VIEW - ANIMAL GENERAL DETAIL</h2>
       <!--<p>Animal general detail</p>-->
       <!--<a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
        Back
       </a>-->
       </div>
      </div>
       <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12">
       <div class="grid_view">
       <h3>&nbsp;</h3>
       <div class="card mt-0">
       <div class="card-body">
       <div class="row">
       <!-- <div class="col-lg-4 col-sm-4 col-12">
          <p><span class="blue">Farm Name:&nbsp;</span><span id="farmname"></span></p>
          </div>
       <div class="col-lg-4 col-sm-4 col-12">
       <p><span class="blue">Species Name:&nbsp;</span><span id="speciesname" ></span></p>
       </div>
       <div class="col-lg-4 col-sm-4 col-12">
        <p><span class="blue">Breed Name:&nbsp;</span><span id="breedname"></span></p>
       </div>
       <div class="col-lg-4 col-sm-4 col-12">
        <p><span class="blue">Animal ID:&nbsp;</span><span id="animalid"></span></p>
        </div>     <div class="col-lg-4 col-sm-4 col-12">
        <p><span class="blue">Vaccination Date:&nbsp;</span><span id="vaccinedate" >{{testdate1 | date:'MM/dd/yyyy'}}</span></p>
        </div>-->
       <div class="col-lg-4 col-sm-4 col-12">
       <p><span class="blue">Animal type:&nbsp;</span><span id="Animaltype"></span></p>
       </div>
       <div class="col-lg-4 col-sm-4 col-12">
       <p><span class="blue">Species:&nbsp;</span><span id="Species" ></span></p>
       </div>
       <div class="col-lg-4 col-sm-4 col-12">
       <p><span class="blue">Breed:&nbsp;</span><span id="Breed" ></span></p>
       </div>
       <div class="col-lg-4 col-sm-4 col-12">
        <p><span class="blue">Gender:&nbsp;</span><span id="Gender" ></span></p>
        </div>
        <div class="col-lg-4 col-sm-4 col-12">
            <p><span class="blue">Age:&nbsp;</span><span id="Age" ></span></p>
            </div>
            <div class="col-lg-4 col-sm-4 col-12">
                <p><span class="blue">Weight:&nbsp;</span><span id="Weight" ></span></p>
                </div>
                <div class="col-lg-4 col-sm-4 col-12">
                    <p><span class="blue">Date Of Birth:&nbsp;</span><span id="birthdate" >{{birthdate | date:'MM/dd/yyyy'}}</span></p>
                    </div>
                    <div class="col-lg-4 col-sm-4 col-12">
                        <p><span class="blue">Date Of Transfer:&nbsp;</span><span id="transferdate" >{{transfdate | date:'MM/dd/yyyy'}}</span></p>
                        </div>
                        <div class="col-lg-4 col-sm-4 col-12">
                            <p><span class="blue">Date Of Purchase:&nbsp;</span><span id="purchasedate" >{{datepurchase| date:'MM/dd/yyyy'}}</span></p>
                            </div>
                 <div class="col-lg-4 col-sm-4 col-12">
              <p><span class="blue">Date Of Deletion:&nbsp;</span><span id="deletedate" >{{datedelete | date:'MM/dd/yyyy'}}</span></p>
                     </div>
        </div>
       </div>
       </div>
       </div>
       </div>
       <div class="col-lg-12 col-md-12 col-sm-12 text-center">
       <button type="submit" (click)='backnavigate()' class="btn btn-fill btn-primary mb-3">
        Back <div class="ripple-container"></div>
       </button>
       <br>
       </div>
       </div>
     </div>
   </div>
 </div>

